import { render } from "./WhatsAppTutorialView.vue?vue&type=template&id=51c1d046&scoped=true"
import script from "./WhatsAppTutorialView.vue?vue&type=script&lang=js"
export * from "./WhatsAppTutorialView.vue?vue&type=script&lang=js"

import "./WhatsAppTutorialView.vue?vue&type=style&index=0&id=51c1d046&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c1d046"]])

export default __exports__